import React from 'react';
import { Checkbox, DateTime, SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { SubscriberGroupSectionType } from '../metroline/types';
import { SubscriberGroupsSection } from '../types';
import { ExternalMemberFormIds } from 'app/area/subscriber-groups/form/constants';
import { createFormatters, createUTCDate, dateToUTC, parseAsDateUTC } from 'app/infrastructure/data/date';

export const SubscriberGroupDetailsContainer: React.FC<SubscriberGroupsSection> = ({
  subscriberGroupItem, section, translation, validation, locale,
  updateItem, resetValidation, getRef, shouldRenderSection
}) => {

  const checkboxOnChange = (selfService: number) => {
    resetValidation(subscriberGroupItem.id, ExternalMemberFormIds.longDescription);
    updateItem({ selfService: !!selfService });
  };

  const onDisabledChange = (disabled: Date) => {
    updateItem({ disabled });
  };

  return <MetroLineSection<SubscriberGroupSectionType>
    section={section}
    sectionType={SubscriberGroupSectionType.Details}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(SubscriberGroupSectionType.Details)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={SubscriberGroupSectionType.Details}
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <Checkbox
              className={undefined}
              info={{
                text: translation.self_service_info,
                visible: true
              }}
              componentId={'allow-self-service-checkbox'}
              onChange={checkboxOnChange}
              label={{ visible: true, text: translation.self_service }}
              value={subscriberGroupItem?.selfService ? 1 : 0} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <DateTime
              componentId={'subscriber-group-details-disabled'}
              className="dateTime"
              value={subscriberGroupItem?.disabled}
              label={translation ? { text: translation.disabled } : undefined}
              readOnly={false}
              useTime={false}
              parseDate={parseAsDateUTC}
              createDate={createUTCDate}
              cloneDate={dateToUTC}
              {...createFormatters(locale)}
              locale={locale}
              onChange={onDisabledChange}
              captionWrapper={'form'}
              validation={validation?.disabled} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
